export default {
  GET_APIKEY_REQUEST: 'APIIntegrationConstants.GET_APIKEY_REQUEST',
  GET_APIKEY_SUCCESS: 'APIIntegrationConstants.GET_APIKEY_SUCCESS',
  GET_APIKEY_FAILURE: 'APIIntegrationConstants.GET_APIKEY_FAILURE',
  DELETE_APIKEY_REQUEST: 'APIIntegrationConstants.DELETE_APIKEY_REQUEST',
  DELETE_APIKEY_SUCCESS: 'APIIntegrationConstants.DELETE_APIKEY_SUCCESS',
  DELETE_APIKEY_FAILURE: 'APIIntegrationConstants.DELETE_APIKEY_FAILURE',
};
